import argentian from "./argentina.webp";
import australia from "./australia.webp";
import brazil from "./brazil.webp";
import canada from "./canada.webp";
import chile from "./chile.webp";
import denmark from "./denmark.webp";
import france from "./france.webp";
import germany from "./germany.webp";
import gb from "./great-britain.webp";
import hongkong from "./hong-kong.webp";
import india from "./india.webp";
import ireland from "./ireland.webp";
import italy from "./italy.webp";
import japan from "./japan.webp";
import newZealand from "./new-zealand.webp";
import peru from "./peru.webp";
import singapore from "./singapore.webp";
import southAfrica from "./south-africa.webp";
import southKorea from "./south-korea.webp";
import spain from "./spain.webp";
import sweden from "./sweden.webp";
import turkey from "./turkey.webp";
import uae from "./uae.webp";
import usa from "./usa.webp";
import uruguay from "./uruguay.webp";
import world from "./world.webp";

//Camel racers
import afghanistan from "./afghanistan.webp";
import algeria from "./algeria.webp";
import bahrain from "./bahrain.webp";
import egypt from "./egypt.webp";
import iran from "./iran.webp";
import iraq from "./iraq.webp";
import jordan from "./jordan.webp";
import kazakhstan from "./kazakhstan.webp";
import kenya from "./kenya.webp";
import kuwait from "./kuwait.webp";
import libya from "./libya.webp";
import morocco from "./morocco.webp";
import oman from "./oman.webp";
import pakistan from "./pakistan.webp";
import qatar from "./qatar.webp";
import saudiArabia from "./saudi-arabia.webp";
import sudan from "./sudan.webp";
import syria from "./syria.webp";
import tunisia from "./tunisia.webp";
import turkmenistan from "./turkmenistan.webp";
import yemen from "./yemen.webp";


export function getFlag(country: string) {
  switch (country) {
    case "Argentina":
      return argentian;
    case "Australia": //Also in camel racing
      return australia;
    case "Brazil":
      return brazil;
    case "Canada":
      return canada;
    case "Chile":
      return chile;
    case "Denmark":
      return denmark;
    case "France":
      return france;
    case "Germany":
      return germany;
    case "Great Britain":
      return gb;
    case "Hong Kong":
      return hongkong;
    case "India":
      return india; //Also in camel racing
    case "Ireland":
      return ireland;
    case "Italy":
      return italy;
    case "Japan":
      return japan;
    case "New Zealand":
      return newZealand;
    case "Peru":
      return peru;
    case "Singapore":
      return singapore;
    case "South Africa":
      return southAfrica;
    case "South Korea":
      return southKorea;
    case "Spain":
      return spain;
    case "Sweden":
      return sweden;
    case "Turkey": //Also in camel racing
      return turkey;
    case "United Arab Emirates":
      return uae; //Also in camel racing
    case "United States":
      return usa;
    case "Uruguay":
      return uruguay;

      case "Afghanistan":
        return afghanistan;
      case "Algeria":
        return algeria;
      case "Bahrain":
        return bahrain;
      case "Egypt":
        return egypt;
      case "Iran":
        return iran;
      case "Iraq":
        return iraq;
      case "Jordan":
        return jordan;
      case "Kazakhstan":
        return kazakhstan;
      case "Kenya":
        return kenya;
      case "Kuwait":
        return kuwait;
      case "Libya":
        return libya;
      case "Morocco":
        return morocco;
      case "Oman":
        return oman;
      case "Pakistan":
        return pakistan;
      case "Qatar":
        return qatar;
      case "Saudi Arabia":
        return saudiArabia;
      case "Sudan":
        return sudan;
      case "Syria":
        return syria;
      case "Tunisia":
        return tunisia;
      case "Turkmenistan":
        return turkmenistan;
      case "Yemen":
        return yemen;





    default:
      return world;
  }
}
